<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          Filtri
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <h2 class="subtitle-1 primary--text mb-2">Stato</h2>
          <v-switch
            dense
            hide-details
            v-model="inserito"
            label="Inserito"
            color="red"
          ></v-switch>
          <v-switch
            dense
            hide-details
            v-model="ordinato"
            label="Ordinato"
            color="orange"
          ></v-switch>
          <v-switch
            dense
            hide-details
            v-model="arrivato"
            label="Arrivato"
            color="blue"
          ></v-switch>
          <v-switch
            dense
            hide-details
            v-model="consegnato"
            label="Consegnato"
            color="green"
          ></v-switch>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  export default {
    name: 'PreordersFilters',

    computed: {
      ...mapGetters(['getPreordiniFiltersStatus']),

      inserito: {
        get() {
          return this.getPreordiniFiltersStatus.inserito
        },
        set(_) {
          this.TOGGLE_PREORDINI_FILTERS_STATUS_INSERITO()
        }
      },
      ordinato: {
        get() {
          return this.getPreordiniFiltersStatus.ordinato
        },
        set(_) {
          this.TOGGLE_PREORDINI_FILTERS_STATUS_ORDINATO()
        }
      },
      arrivato: {
        get() {
          return this.getPreordiniFiltersStatus.arrivato
        },
        set(_) {
          this.TOGGLE_PREORDINI_FILTERS_STATUS_ARRIVATO()
        }
      },
      consegnato: {
        get() {
          return this.getPreordiniFiltersStatus.consegnato
        },
        set(_) {
          this.TOGGLE_PREORDINI_FILTERS_STATUS_CONSEGNATO()
        }
      },
    },

    methods: {
      ...mapMutations([
        'TOGGLE_PREORDINI_FILTERS_STATUS_INSERITO',
        'TOGGLE_PREORDINI_FILTERS_STATUS_ORDINATO',
        'TOGGLE_PREORDINI_FILTERS_STATUS_ARRIVATO',
        'TOGGLE_PREORDINI_FILTERS_STATUS_CONSEGNATO'
      ])
    }
  }
</script>

<style>
</style>